export default "__VITE_ASSET__m0$tfYhC__"